import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const SeasonWeekNumberButton = ({
    semesterSeason,
    semesterWeekNum,
    colors,
    getSemesterSeason,
    setDate,
}) => {

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [value, setValue] = React.useState(dayjs());

    return (
        <>
            <button
                style={{
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                    color: colors.primary[600],
                    padding: 0,
                    textAlign: "center",
                    width: "100%",
                }}
                onClick={() => {
                    handleOpen();
                    console.log("Clicked on this week button");
                }}
            >
                <Typography variant="h7">
                    {getSemesterSeason(semesterSeason, semesterWeekNum)}
                </Typography>
            </button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" mb={2}>
                        Select a date to view the weekly schedule
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                            <DatePicker
                                label="Select Date"
                                value={value}
                                onChange={(newValue) => setValue(newValue)}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                    <Button
                        variant="contained"
                        sx={{ mt: 2 }}
                        onClick={() => {
                            setDate(value);
                            handleClose();
                        }}
                    >
                        Apply
                    </Button>
                </Box>
            </Modal>
        </>
    )
}

export default SeasonWeekNumberButton